/**
 * /w/:token — a personal link a Kono BDR put in an email ("see it on kono.ai").
 * Tells the platform the link was opened (so the BDR hears about it and this
 * browser's later visits are attributed to the same person) and sends the
 * visitor on to the page the BDR chose. Nothing is shown; a bad token simply
 * lands on the home page.
 */
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { sendRequest } from "../common/functions";
import { getTrackingIds } from "../visitorTracking";

const inviteBase = (): string => {
  const userApiBaseUrl = process.env.REACT_APP_USER_API_BASE_URL;
  if (!userApiBaseUrl) throw new Error("Missing REACT_APP_USER_API_BASE_URL");
  return userApiBaseUrl.replace(/\/users$/, "/invite");
};

const TrackedLinkPage = () => {
  const { token = "" } = useParams<{ token: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    let landing = "/";
    const go = () => navigate(landing.startsWith("/") ? landing : "/", { replace: true });
    const visitorId = getTrackingIds()?.visitorId;
    sendRequest(`${inviteBase()}/w/${encodeURIComponent(token)}${visitorId ? `?v=${encodeURIComponent(visitorId)}` : ""}`, { method: "GET" })
      .then(async (r) => {
        const body = await r.json().catch(() => ({}));
        if (typeof body?.landing_path === "string") landing = body.landing_path;
      })
      .catch(() => undefined)
      .finally(go);
  }, [token, navigate]);

  return null;
};

export default TrackedLinkPage;
